<template>
  <div class="snippet-details details">
    <div class="close" v-on:click="close()">
      <b-icon icon="close" size="is-large" />
    </div>
    <b-field>
      <b-radio-button v-model="textFormat" native-value="text" type="is-light">Plain Text</b-radio-button>
      <b-radio-button v-model="textFormat" native-value="html" type="is-success">HTML</b-radio-button>
      <b-radio-button v-model="textFormat" native-value="custom" type="is-success">Source HTML</b-radio-button>
    </b-field>
    <h3 class="snippet-key">{{snippet.key|toWords}}</h3>
    <b-field label="Text">
      <b-input v-if="!showEditor" maxlength="200" rows="8" type="textarea" v-model="textValue"></b-input>
      <vue-editor
        v-if="showEditor"
        id="text-editor"
        :editorToolbar="customToolbar"
        v-model="textValue"
      ></vue-editor>
    </b-field>
    <b-button type="is-success" @click="save" class="save" rounded>Save</b-button>
    <p v-if="saveMessage.length > 2" class="message">{{saveMessage}}</p>
    <ul v-if="numFiles > 0" class="files">
      <li v-for="(file, index) in files" :key="[file.key, index].join('-')">
        <span class="copy" :class="{'copied':file.copied}" @click="copyPath(file)">
          <b-icon icon="content-copy" size="is-small" />
        </span>
        <a :href="file.fullPath" target="_blank" :id="file.key">{{file.fullPath}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { VueEditor } from "vue2-editor";
import filters from "../mixins/filters";
import { saveSnippet, readDirectory } from "../api/methods";
import { toMillitime } from "../api/helpers";

export default {
  name: "SnippetDetail",
  components: {
    VueEditor
  },
  props: {
    snippet: {
      type: Object,
      default() {
        return {
          _id: "",
          key: "",
          format: "",
          value: "",
          createdAt: "",
          modifiedAt: ""
        };
      }
    }
  },
  mixins: [filters],
  mounted() {
    if (this.snippet instanceof Object) {
      if (this.snippet.value) {
        this.textValue = this.snippet.value;
        if (this.snippet.format) {
          this.textFormat = this.snippet.format;
        }
      }
      this.listUploads();
    }
  },
  created() {},
  data() {
    return {
      textValue: "",
      textFormat: "text",
      saveMessage: "",
      files: []
    };
  },
  computed: {
    ...mapGetters(["snippets", "customToolbar"]),
    showEditor() {
      return this.textFormat === "html";
    },
    numFiles() {
      return this.files.length;
    }
  },
  methods: {
    ...mapMutations(["setSnippets"]),
    close() {
      this.$parent.close();
    },
    save() {
      const { _id } = this.snippet;
      const format = this.textFormat === "text" ? this.textFormat : "html";
      saveSnippet(_id, {
        value: this.textValue,
        format
      }).then(data => {
        if (data.valid) {
          const { snippet } = data;
          const index = this.snippets.findIndex(s => s.key === snippet.key);

          if (index >= 0) {
            let sns = this.snippets;
            sns[index].value = snippet.value;
            sns[index].format = snippet.format;
            this.setSnippets(sns);
            this.$parent.sourceList = this.$parent.sourceList.map(sn => {
              if (sn._id === _id) {
                sn.value = snippet.value;
                sn.format = snippet.format;
              }
              return sn;
            });
            this.saveMessage = "Snippet successfully saved";
            setTimeout(() => {
              this.$parent.close();
            }, 1000);
            setTimeout(() => {
              this.saveMessage = "";
            }, 1500);
          }
        }
      });
    },
    listUploads() {
      readDirectory("files").then(data => {
        if (data.files instanceof Array) {
          this.files = data.files.map((file, index) => {
            file.fullPath = "/files/" + file.name;
            file.key = [
              "upload",
              file.mtime.replace(/[^0-9]/g, ""),
              index
            ].join("-");
            file.copied = false;
            return file;
          });
          this.files.sort(
            (a, b) => toMillitime(b.mtime) - toMillitime(a.mtime)
          );
        }
      });
    },
    resetFilesStatus() {
      this.files = this.files.map(f => {
        f.copied = false;
        return f;
      });
    },
    copyPath(file) {
      if (file instanceof Object) {
        if (file.fullPath) {
          if (navigator.clipboard) {
            this.resetFilesStatus();
            if (navigator.clipboard.writeText) {
              navigator.clipboard.writeText(file.fullPath).then(result => {
                if (result) {
                  file.copied = true;
                  setTimeout(this.resetFilesStatus, 5000);
                }
              });
            }
          }
        }
      }
    }
  }
};
</script>